import {createSelector} from 'reselect';
import DisabledCheckoutPageCalls from '../../../../enums/DisabledCheckoutPageCalls';
import {getDisabledCheckoutPageCalls} from '../../getDisabledCheckoutPageCalls';
import {getPaymentOptions} from '../PaymentOptionSelectors';

export default createSelector(
  [getPaymentOptions, getDisabledCheckoutPageCalls, state => state.payment?.optty],
  (availablePaymentOptions, disabledCheckoutPageCalls, optty) => availablePaymentOptions
    .some(paymentOption => paymentOption.name === 'OPTTY')
    && !disabledCheckoutPageCalls.includes(DisabledCheckoutPageCalls.OPTTY_SESSION)
    && !!optty,
);
